import { fetchItemsWithFlow } from "directus/src/operations";

const FLOW_ID = "3fde7bc1-fe69-488f-8684-d619a3c18e76";

export async function fetchDepartmentTimesheetChart(filters = {}) {
  const response = await fetchItemsWithFlow(FLOW_ID, filters);

  return {
    departmentData: response?.chartData || [],

    orgData: response?.organizationAverage || null,

    raw: response,
  };
}
